import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ITraderGroupLookupService } from "../ITraderGroupLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export const DEFAULT_TRADER_GROUP: number = -1;

export const CHECK_TRADER_GROUP_VISIBILITY = (traderGroup: CubiqTS.TradingGroupImpl) => {
  return traderGroup?.groupId?.toNumber != null &&
    traderGroup.groupId.toNumber() >= DEFAULT_TRADER_GROUP;
}

@Injectable()
export class TraderGroupLookupService
  extends BaseLookupService<string, CubiqTS.TradingGroupImpl>
  implements ITraderGroupLookupService
{
  private traderGroupNameMap: any = {};

  constructor() {
    super(CubiqTS.TradingGroupImpl);
  }

  getTraderGroup(id: CubiqTS.Long): CubiqTS.TradingGroupImpl {
    if (id == undefined || id == null) return null;
    var traderGrp = this.getItem(id.toString());
    return traderGrp;
  }

  getTraderGroupForSid(sid: string): CubiqTS.TradingGroupImpl {
    if (sid == undefined || sid == null) {
      return null;
    } else {
      var traderGrp = this.getItem(sid);
      return traderGrp;
    }
  }

  getTraderGroupByName(tgName: string): CubiqTS.TradingGroupImpl {
    return this.traderGroupNameMap[tgName];
  }

  getItemKey(item: any): string {
    if (item.groupId != undefined && item.groupId != null) return item.groupId.toString();
    return null;
  }

  mapItem(item: CubiqTS.TradingGroupImpl): void {
    if (CHECK_TRADER_GROUP_VISIBILITY(item)) {
      super.mapItem(item);

      if (item != null) {
        this.traderGroupNameMap[item.groupCode] = item;
      }
    }
  }

  deleteItem(item: CubiqTS.TradingGroupImpl, id: string = null): void {
    super.deleteItem(item, id);
    if (item != null) {
      delete this.traderGroupNameMap[item.groupCode];
    }
  }
}
